import React from "react";
import "./noTestimonal.scss";

function NoTestimonal({ color }) {
  return (
    <div className="container-wrapper-no">
      <div className=" centered-div">
        <p className="no-testimonal">No testimonials added yet!</p>
      </div>
    </div>
  );
}

export default NoTestimonal;
